var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4752_1953)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 40,
    height: 40,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9999 50.4583C52.7501 50.4583 53.3583 49.8502 53.3583 49.1C53.3583 48.3498 52.7501 47.7417 51.9999 47.7417C51.2497 47.7417 50.6416 48.3498 50.6416 49.1C50.6416 49.8502 51.2497 50.4583 51.9999 50.4583Z",
    fill: "#0C78F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2337 43.9417V42.9C57.2337 40.65 56.692 37.6667 52.0003 37.6667C47.3087 37.6667 46.767 40.65 46.767 42.9V43.9417C44.4337 44.2333 43.667 45.4167 43.667 48.325V49.875C43.667 53.2917 44.7087 54.3333 48.1253 54.3333H55.8753C59.292 54.3333 60.3337 53.2917 60.3337 49.875V48.325C60.3337 45.4167 59.567 44.2333 57.2337 43.9417ZM52.0003 51.6167C50.6087 51.6167 49.4837 50.4833 49.4837 49.1C49.4837 47.7083 50.617 46.5833 52.0003 46.5833C53.3837 46.5833 54.517 47.7167 54.517 49.1C54.517 50.4917 53.392 51.6167 52.0003 51.6167ZM48.1253 43.8667C48.0587 43.8667 48.0003 43.8667 47.9337 43.8667V42.9C47.9337 40.4583 48.6253 38.8333 52.0003 38.8333C55.3753 38.8333 56.067 40.4583 56.067 42.9V43.875C56.0003 43.875 55.942 43.875 55.8753 43.875H48.1253V43.8667Z",
    fill: "#0C78F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.25,
    y: 26.25,
    width: 39.5,
    height: 39.5,
    rx: 9.75,
    stroke: "#0C78F1",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4752_1953",
    x: 0,
    y: 0,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.243137 0 0 0 0 0.490196 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4752_1953"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.243137 0 0 0 0 0.490196 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4752_1953",
    result: "effect2_dropShadow_4752_1953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4752_1953",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.681263e53272fb01cd8589ce340adf48.svg";
export { ForwardRef as ReactComponent };